import { create } from 'zustand';
import type { ReactNode } from 'react';

export type DrawerConfig = {
  title: string;
  body: ReactNode;
  foot?: ReactNode;
};

type DrawerState = {
  open: boolean;
  config: DrawerConfig | null;
  show: (c: DrawerConfig) => void;
  close: () => void;
};

export const useDrawerStore = create<DrawerState>((set) => ({
  open: false,
  config: null,
  show: (c) => set({ open: true, config: c }),
  close: () => set({ open: false }),
}));

export const openDrawer = (c: DrawerConfig) => useDrawerStore.getState().show(c);
export const closeDrawer = () => useDrawerStore.getState().close();
